module.exports = __webpack_public_path__ + "img/phone-one.e0e4ec46.png";